import { Typography as e } from "../../../Typography/Typography.mjs";
import { useMobile as t } from "../../../hooks/useMobile.mjs";
import { Popup as n } from "../../Popup/Popup.mjs";
import { CalendarMonth as r } from "./CalendarMonth.mjs";
import { MobileCalendarContent as i, SinglePopup as a } from "../styled/Popups.styled.mjs";
import { useCalendarNavigation as o } from "../hooks/useCalendarNavigation.mjs";
import { ClearBtn as s, Placeholder as c, Root as l, Trigger as u, TriggerInner as d } from "../styled/DatePicker.styled.mjs";
import { useOutsideClose as f } from "../../../hooks/useOutsideClose.mjs";
import { useRef as p, useState as m } from "react";
import { useTranslation as h } from "@maat/store-i18n";
import { jsx as g, jsxs as _ } from "react/jsx-runtime";
import { CalendarDays as v, X as y } from "lucide-react";
import { formatDatePicker as b } from "@maat/datetime";
//#region src/components/DatePicker/components/DatePicker.tsx
var x = ({ value: x, onChange: S, placeholder: C, disabled: w, minDate: T, maxDate: E, label: D, error: O, className: k, annotations: A, blockedRanges: j }) => {
	let { t: M } = h("ds"), { isMobile: N } = t(), [P, F] = m(!1), I = C ?? M("ds:datePicker.selectDate"), { view: L, navigate: R, setView: z } = o({ initialValue: x }), B = p(null);
	f(B, {
		enabled: !N,
		onClose: () => F(!1)
	});
	let V = /* @__PURE__ */ g(i, { children: /* @__PURE__ */ g(r, {
		year: L.year,
		month: L.month,
		onPrev: () => R(-1),
		onNext: () => R(1),
		onSetView: z,
		selectedDate: x,
		onDayClick: (e) => {
			S?.(e), F(!1);
		},
		minDate: T,
		maxDate: E,
		annotations: A,
		blockedRanges: j,
		hidePrev: !0,
		hideNext: !0,
		fluid: !0
	}) });
	return /* @__PURE__ */ _(l, {
		ref: B,
		className: k,
		children: [
			D && /* @__PURE__ */ g(e, {
				variant: "label",
				children: D
			}),
			/* @__PURE__ */ _(u, {
				type: "button",
				$open: P,
				$error: !!O,
				$disabled: w,
				disabled: w,
				onClick: () => F((e) => !e),
				"aria-haspopup": "dialog",
				"aria-expanded": P,
				children: [/* @__PURE__ */ _(d, { children: [/* @__PURE__ */ g(v, {
					size: 15,
					opacity: .6
				}), x ? /* @__PURE__ */ g("span", { children: b(x) }) : /* @__PURE__ */ g(c, { children: I })] }), x && /* @__PURE__ */ g(s, {
					type: "button",
					onClick: (e) => {
						e.stopPropagation(), S?.(null);
					},
					"aria-label": M("common:actions.clear"),
					children: /* @__PURE__ */ g(y, { size: 13 })
				})]
			}),
			N ? /* @__PURE__ */ g(n, {
				open: P,
				onClose: () => F(!1),
				title: D ?? M("ds:datePicker.selectDate"),
				children: V
			}) : P && /* @__PURE__ */ g(a, {
				role: "dialog",
				"aria-label": M("ds:datePicker.dialogLabel"),
				children: /* @__PURE__ */ g(r, {
					year: L.year,
					month: L.month,
					onPrev: () => R(-1),
					onNext: () => R(1),
					onSetView: z,
					selectedDate: x,
					onDayClick: (e) => {
						S?.(e), F(!1);
					},
					minDate: T,
					maxDate: E,
					annotations: A,
					blockedRanges: j
				})
			}),
			O && /* @__PURE__ */ g(e, {
				variant: "caption",
				color: "error",
				children: O
			})
		]
	});
};
//#endregion
export { x as DatePicker };
